import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    cacheHeightKeyPrefix: String,
  };

  connect() {
    this.storageKey   = `${this.cacheHeightKeyPrefixValue}Height`;
    this.resizing     = false;
    this.startClientY = 0;
    this.startHeight  = 0;
    this.initHeight   = this.element.offsetHeight;

    document.addEventListener('mouseup', this.mouseUpHandler.bind(this));
    document.addEventListener('mousemove', this.mouseMoveHandler.bind(this));

    this.setDefaultHeight();    
  }

  resize(event) {
    const y = (this.startClientY - event.clientY) * 1.05;
    const resizedHeight = this.startHeight + y;

    if (resizedHeight >= this.initHeight) {
      this.element.style.height = `${resizedHeight}px`;
      localStorage.setItem(this.storageKey, resizedHeight);
    }
  }

  mouseDownHandler(event) {
    this.resizing     = true;
    this.startClientY = event.clientY;
    this.startHeight  = this.element.offsetHeight;
  }

  mouseUpHandler() {
    this.resizing = false;
  }

  mouseMoveHandler(event) {
    if(this.resizing) {
      this.resize(event);
    }
  }

  setDefaultHeight() {
    const defaultHeight = localStorage.getItem(this.storageKey);

    if (defaultHeight) {
      this.element.style.height = `${defaultHeight}px`;
    }
  }
}
